import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import {
  checkLevelToGetRewards,
  getActiveReward,
  getIsBoughtPlan,
  getPaidRewardPlanCost,
} from '@/redux/selectors/earnRewardsSelector';
import { useAppSelector } from '@/redux/store';

/** Whether the Reward Track has something for the player (banner shown). */
const useRewardTrackAvailable = (): boolean => {
  const congruentLevel = useAppSelector(checkLevelToGetRewards);
  const activeReward = useAppSelector(getActiveReward);
  const cost = useAppSelector(getPaidRewardPlanCost);
  const isBoughtPlan = useAppSelector(getIsBoughtPlan);

  return congruentLevel && (!!activeReward || (!!cost && !isBoughtPlan));
};

/** A reward of the track can be claimed right now. */
const useRewardTrackClaimable = (): boolean => {
  const nextClaimTime = useAppSelector(
    (state) => state.earnRewards.rewards?.nextClaimTime,
  );
  const seconds = useCountDownTimer(nextClaimTime || 0);
  const available = useRewardTrackAvailable();

  return available && nextClaimTime !== undefined && !seconds;
};

export { useRewardTrackAvailable, useRewardTrackClaimable };
